'use client';
import React, { FC } from 'react';

import Image from '@/components/core/Image';
import { useTranslation } from '@/hooks/useTranslations';
import blocksImg from '@/public/assets/Images/blocks.png';
import fileImg from '@/public/assets/Images/file.png';
import groupImg from '@/public/assets/Images/Group.png';
import personImg from '@/public/assets/Images/person.png';

import './styles.scss';

const OurVision: FC = () => {
  const { t } = useTranslation();

  const successBlocks = [
    { image: groupImg, label: 'Aboutus-Keyword-one' },
    { image: blocksImg, label: 'Aboutus-Keyword-Two' },
    { image: personImg, label: 'Aboutus-Keyword-Three' },
  ];

  return (
    <div className="ourVisionWrapper">
      <div className="ourVisionBlockItem">
        <h2 className="ourVisionBlockTitle">{t('Aboutus-Ourvision-title')}</h2>
        <p className="ourVisionText">{t('Aboutus-Ourvision-Desc')}</p>
      </div>
      <div className="ourVisionFeaturesContainer">
        {successBlocks.map((item) => (
          <div className="ourVisionFeatures" key={item.label}>
            <Image src={item.image} alt="" className="featureImage" />
            <p className="ourVisionBlockTitle featureTitle">{t(item.label)}</p>
          </div>
        ))}
      </div>
      <div className="socialCommitmentBlock">
        <div className="socialCommitmentBlockLeft">
          <h2 className="ourVisionBlockTitle socialBackofficeTitle">
            {t('Aboutus-Our Commitment-Title')}
          </h2>
          <p className="socialBackofficeText">{t('Aboutus-Our Commitment-Paragraph')}</p>
        </div>
        <div className="socialCommitmentBlockRight">
          <h3 className="socialCommitmentBlockRightTitle">{t('Aboutus-GamblingAware-Title')}</h3>
          <p className="socialCommitmentBlockRightText">{t('Aboutus-GamblingAware-paragraph')}</p>
        </div>
      </div>
      <div className="backofficeBlock">
        <Image src={fileImg} alt="" className="backofficeImage" />
        <div className="backofficeBlockRight">
          <h2 className="ourVisionBlockTitle socialBackofficeTitle">
            {t('Aboutus-OurBackoffice-Title')}
          </h2>
          <p className="socialBackofficeText">{t('Aboutus-OurBackoffice-Paragraph')}</p>
        </div>
      </div>
    </div>
  );
};

export default OurVision;
